import React, { useState } from "react";

import style from "./notificationToast.module.css";
import infoIcon from "../../images/info.png";
import errorIcon from "../../images/error.png";
import successIcon from "../../images/success.png";
import closeIcon from "../../images/closeIcon.png";

const NotificationToast = props => {
  const { type, text } = props;
  const [display, setDisplay] = useState("block");
  console.log(type, text, style);
  function getImage() {
    switch (type) {
      case "I":
        return infoIcon;
      case "E":
        return errorIcon;
      case "S":
        return successIcon;
      default:
        console.log("Invalid type");
    }
  }
  return (
    <div
      className={`${style.notificationContainer} ${
        type === "I"
          ? style.informationColor
          : type === "E"
          ? style.errorColor
          : style.successColor
      }`}
      style={{ display }}
    >
      <div
        className="d-f"
        style={{
          justifyContent: "space-between",
          padding: "0 8px",
          alignItems: "center"
        }}
      >
        <div>
          <img className={style.image} src={getImage()} alt="Info type" />
        </div>
        <p style={{ textAlign: "left", marginRight: "10px" }}>{text}</p>
        <div>
          <img
            alt={"Close Button"}
            src={closeIcon}
            style={{ cursor: "pointer" }}
            onClick={() => setDisplay("none")}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationToast;
